import { MODAL_SIZES } from 'js/src/components/common/ui/modal';

export const customVideos = [
    {
        poster: 'https://storage.googleapis.com/lumen5-site-images/enterprise-page-videos/kpmg-cover.webp',
        aspectRatio: 'landscape',
        modalSize: MODAL_SIZES.XL,
        src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/kpmg-template.webm',
    },
    {
        poster: 'https://storage.googleapis.com/lumen5-site-images/enterprise-page-videos/sap-cover.webp',
        aspectRatio: 'landscape',
        modalSize: MODAL_SIZES.XL,
        src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/sap-template.webm',
    },
    {
        poster: 'https://storage.googleapis.com/lumen5-site-images/enterprise-page-videos/cbre-cover.webp',
        aspectRatio: 'landscape',
        modalSize: MODAL_SIZES.XL,
        src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/cbre-template.webm',
    },
    {
        poster: 'https://storage.googleapis.com/lumen5-site-images/enterprise-page-videos/finland-cover.webp',
        aspectRatio: 'landscape',
        modalSize: MODAL_SIZES.XL,
        src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/finland-template.webm',
    },
];

const tags = [
    {
        id: 'consulting',
        displayName: 'Consulting',
    },
    {
        id: 'industrial',
        displayName: 'Industrial',
    },
    {
        id: 'finance',
        displayName: 'Finance',
    },
    {
        id: 'consumer',
        displayName: 'Consumer',
    },
    {
        id: 'technology',
        displayName: 'Technology',
    },
    {
        id: 'healthcare',
        displayName: 'Healthcare',
    },
];

export type HomepageVideoDetails = {
    poster: string;
    aspectRatio: string;
    modalSize: MODAL_SIZES;
    src: string;
};

const taggedVideos: Record<string, HomepageVideoDetails[]> = {
    consulting: [
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/kpmg-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/kpmg-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/sap-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/sap-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/adp-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/adp-vid.webm',
        },
    ],
    industrial: [
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/johncrane-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/johncrane-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/emerson-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/emerson-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/siemens-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/siemens-vid.webm',
        },
    ],
    finance: [
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/hub-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/hub-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/swissre-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/swissre-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/beneva-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/beneva-vid.webm',
        },
    ],
    consumer: [
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/bestwestern-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/bestwestern-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/unilever-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/unilever-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/pg-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/pg-vid.webm',
        },
    ],
    technology: [
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/circleci-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/circleci-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/emplifi-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/emplifi-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/lookout-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/lookout-vid.webm',
        },
    ],
    healthcare: [
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/menarini-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/menarini-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/msd-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/msd-vid.webm',
        },
        {
            poster: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/hinge-img.webp',
            aspectRatio: 'landscape',
            modalSize: MODAL_SIZES.XL,
            src: 'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/home-videos/hinge-vid.webm',
        },
    ],
};

export const logoImages = [
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/ADP.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Cisco.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Colliers.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/DNV.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Emerson.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Financial%20Times.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/KPMG.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Lixil.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Mitsubishi.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/PWC.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/SAP.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Sanofi.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Siemens.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Sodexo.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/Swiss%20Re.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/The%20Independent.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/UBS.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/UGA.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/cognizant.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/color/moodys.webp',
];

export const logoImagesDark = [
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/ADP.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Cisco.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Colliers_Black.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/DNV.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Emerson_Black.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Financial%20Times.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/KPMG.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Lixil.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Mitsubishi.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/PWC.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/SAP.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/SIEMENS.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Sanofi.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Sodexo.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/Swiss%20Re.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/The%20Independent.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/UBS_White.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/UGA_White.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/cognizant.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/black/moodys.webp',
];

export const logoImagesLight = [
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/ADP.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Cisco.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Colliers_White.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/DNV.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Emerson_White.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Financial%20Times.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/KPMG.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Lixil.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Mitsubishi.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/PWC.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/SAP.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Sanofi.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Siemens.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Sodexo.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/Swiss%20Re.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/The%20Independent.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/UBS_White.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/UGA_White.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/cognizant.webp',
    'https://storage.googleapis.com/lumen5-site-images/2025-website-assets/logos/white/moodys.webp',
];

/* Selectors */
export const getTagIds = () => tags.map(({ id }) => id);
export const getTagNameById = (id: string) => {
    const tag = tags.find((tag) => tag.id === id);
    return tag ? tag.displayName : '';
};
export const getDefaultTagId = () => tags[0].id;
export const getVideosByTagId = (tagId: string) => taggedVideos[tagId];
